import type {
  SpartanLineupEngine,
  SpartanLineupStyleName,
  SpartanLineupTone,
} from '@/app/lcv/components/sections/spartan/shared/lineup/types';
import type {
  SpartanTabsIndicatorKind,
  SpartanTabsIndicatorTone,
  SpartanTabsVariant,
} from '@/app/lcv/components/sections/spartan/shared/tabs/types';

interface SpartanLineupModelCardStyleOptions {
  tone?: SpartanLineupTone;
  styleName?: SpartanLineupStyleName;
  engineKey?: SpartanLineupEngine['engineKey'];
  modelTitle?: string;
}

const isBiturbo = (engineKey?: SpartanLineupEngine['engineKey']): boolean =>
  engineKey === '2.2 Biturbo';

export const getSpartanLineupModelCardSurfaceClassName = ({
  tone = 'light',
  styleName,
}: SpartanLineupModelCardStyleOptions) => {
  if (tone === 'light') return 'bg-silver-100';
  if (styleName === 'x-series') return 'bg-gray-900';

  return 'bg-black/50';
};

export const getSpartanLineupEngineTabsVariant = ({
  tone = 'light',
}: SpartanLineupModelCardStyleOptions): SpartanTabsVariant =>
  tone === 'dark' ? 'dark' : 'soft';

export const getSpartanLineupEngineIndicatorKind = ({
  engineKey,
}: SpartanLineupModelCardStyleOptions): SpartanTabsIndicatorKind | undefined =>
  // Soft/light tracks need an explicit glow kind for the orange pill to render.
  isBiturbo(engineKey) ? 'glow' : undefined;

export const getSpartanLineupEngineIndicatorTone = ({
  tone = 'light',
  engineKey,
}: SpartanLineupModelCardStyleOptions &
  Pick<SpartanLineupEngine, 'engineKey'>):
  | SpartanTabsIndicatorTone
  | undefined => {
  if (isBiturbo(engineKey)) return 'orange';
  if (tone !== 'dark') return undefined;

  return 'white';
};
